import Vue from 'vue'
import Vuex from 'vuex'
import {decryptData, encryptData} from "@/global-config/store/encryptionService";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        ...localStorage,
        excelLoader:false,
        pdfLoader:false,
        showExportConfirmationModal:false,
        showTransactionDetails:false,
        downloadReportRequestData:null,
        chosenPage:1,
        forceRerenderPagination:false,
        departmentTab_custom:[],
        caseTypeTab_custom:[],
        merchantTmsList_custom:[],
        cardMetaData_custom:[],
        currency_custom:[],
        pos_custom:[],
        paymentMethod_custom:[],
        setting_custom:[],
        schemaMain_custom:[],
        group_custom:[],
        charge_custom:[],
        acquiringMain_custom:[],
        permissions_custom:[],
        merchantChannelList_custom:[],
        roles_custom:[],
        features_custom:[],
        transactions_custom:[],
        gateway_pending_transactions_custom:[],
        preauth_transactions_custom:[],
        gateway_failure_transactions_custom:[],
        merchantPersistFilters: null,
        partnerPersistFilters: null,
        perPageSettings: {},
    },
    getters: {
        getByKey: (state) => (key) => {
            if(typeof (state[key]) != 'undefined'){
                try {
                    const decrypted = decryptData(state[key]);
                    return JSON.parse(decrypted);
                } catch (e) {
                    console.warn(`Failed to decrypt ${key}:`, e);
                    return null;
                }
            }else{
                return null
            }
        },
        getChosenPage(state) {
            return state.chosenPage
        },
        getTableData: (state) => (key) => {
            if(typeof (state[key]) != 'undefined'){
                return state[key]
            }else{
                return null
            }
        },
        getMerchantPersistFilters(state) {
            return state.merchantPersistFilters
        },
        getPartnerPersistFilters(state) {
            return state.partnerPersistFilters
        },
        getPerPageSetting: (state) => (route) => {
            return state.perPageSettings[route] || null;
        }
    },
    mutations: {
        setPerPageSetting(state, { route, value }) {
            state.perPageSettings = {
                ...state.perPageSettings,
                [route]: value
            }
        },
        set(state, payload) {
            if (payload) {
                const encryptedValue = encryptData(JSON.stringify(payload));
                localStorage.setItem(payload.key, encryptedValue)
                state[payload.key] = localStorage.getItem(payload.key);
            }
        },
        setWithoutLocalStorage(state, payload) {
            if (payload) {
                state[payload.key] = encryptData(JSON.stringify(payload));
            }
        },
        setExcelLoader(state, payload) {
            state.excelLoader = payload
        },
        setPdfLoader(state, payload) {
            state.pdfLoader = payload
        },
        setShowExportConfirmationModal(state, payload) {
            state.showExportConfirmationModal = payload
        },
        setShowTransactionDetails(state, payload) {
            state.showTransactionDetails = payload
        },
        setDownloadReportRequestData(state, payload) {
            state.downloadReportRequestData = payload
        },
        setChosenPage(state, payload) {
            state.chosenPage = payload
        },
        setForceRerenderPagination(state, payload) {
            state.forceRerenderPagination = payload
        },
        setTableData(state, payload) {
            // state[payload.key] = JSON.stringify(payload.data)
            state[payload.key] = payload.data
        },
        setMerchantPersistFilters(state, payload) {
            state.merchantPersistFilters = payload
        },
        setPartnerPersistFilters(state, payload) {
            state.partnerPersistFilters = payload
        }


    },
    actions: {
        set(context, payload) {
            context.commit('set', payload)
        },
        setWithoutLocalStorage(context, payload) {
            context.commit('setWithoutLocalStorage', payload)
        },
        exportExcelLoader(context, payload) {
            context.commit('setExcelLoader', payload)
        },
        exportPdfLoader(context, payload) {
            context.commit('setPdfLoader', payload)
        },
        triggerShowExportConfirmationModal(context, payload) {
            context.commit('setShowExportConfirmationModal', payload)
        },
        triggerShowTransactionDetails(context, payload) {
            context.commit('setShowTransactionDetails', payload)
        },
        mutateDownloadReportRequestData(context, payload) {
            context.commit('setDownloadReportRequestData', payload)
        },
        renderPagination(context, payload) {
            context.commit('setForceRerenderPagination', payload)
        },
        setTableData(context, payload) {
            context.commit('setTableData', payload)
        },
        setMerchantPersistFilters(context, payload) {
            context.commit('setMerchantPersistFilters', payload)
        },
        setPartnerPersistFilters(context, payload) {
            context.commit('setPartnerPersistFilters', payload)
        }

    }
})
